<div class="wrapper">
  <div class="create-metric-form-container">
    <div class="indicator-wrapper">
      <gh-indicator [ghValue]="indicators.loading" [ghMessage]="'loading' | localize"></gh-indicator>
    </div>

    <div class="close-btn-wrapper">
      <button (click)="closeModal()" (keydown)="closeModal($event)" ui-button uiType="link">
        <i ui-icon uiTheme="fill" uiType="ui-1_simple-remove"></i>
      </button>
    </div>

    <no-permissions
      *ngIf="
        ((!isEdit && allowedActions.indexOf('create') === -1) || (isEdit && allowedActions.indexOf('update') === -1) || (permissionsFacade.hasPermission$('ManageGoals') | async)) === false &&
        !indicators.loading
      "
      (dismiss)="closeModal()"></no-permissions>

    <div *ngIf="(!isEdit && allowedActions.indexOf('create') !== -1) || (isEdit && allowedActions.indexOf('update') !== -1)">
      <div *ngIf="(permissionsFacade.hasPermission$('ManageGoals') | async) && !indicators.loading" role="dialog" aria-labelledby="form-title">
        <limitations-reached
          *ngIf="metricsLimitReached || goal.locked"
          [metricsLimit]="metricMethodologySettings?.metricsPerGoalLimit"
          [metricsLimitReached]="metricsLimitReached"
          [goal]="goal"
          [session]="session"
          (dismiss)="closeModal()"></limitations-reached>

        <div id="create-metric-form" [hidden]="metricsLimitReached || (goal.locked && !session.workflow?.editableKrFields)">
          <form class="form" [formGroup]="form">
            <header class="header-title">
              <h2 class="main-heading" *ngIf="!isEdit">{{ "create_manual_kr" | localize }}</h2>
              <h2 class="main-heading" *ngIf="isEdit">{{ "edit_manual_kr" | localize }}</h2>
              <span class="heading-subtitle">{{ "all_required_fields_are_marked_with_an_asterisk" | localize }}</span>
            </header>
            <div class="form-section">
              <div class="form-row">
                <label class="section-label" for="metric-title">{{ "title" | localize }}<span aria-hidden="true">*</span></label>
                <div class="section-field metric-title">
                  <ui-input-text-field
                    [debounceTime]="0"
                    [focusMe]="(focus$ | async) === 'shouldFocusTitleInput'"
                    [uiPlaceholder]="'enter_your_kr' | localize"
                    [a11yRequired]="true"
                    [a11yDescription]="('title_most_visible_part_of_kr_should_be' | localize) + ' ' + ('increase_revenue_from_twenty_to_thirty' | localize)"
                    (blur)="updateFocus(null)"
                    formControlName="name"
                    e2eTestId="key-result-modal-title-input"
                    uiId="metric-title"
                    updateOn="change"></ui-input-text-field>
                  <help-tooltip [content]="titleTemplate"></help-tooltip>
                </div>
              </div>
              <div class="form-row">
                <label class="section-label" for="metric-type-selector">{{ "key_result_type" | localize }}</label>
                <div class="section-field metric-type">
                  <metric-type-selector
                    [a11yLabel]="'key_result_type' | localize"
                    [options]="typeOptions"
                    [a11yDescription]="('type_of_KR_needed_detemermine_progress_choose_type' | localize) + ' ' + ('maintain_more_than_fifty_subscribers' | localize)"
                    formControlName="type"
                    data-test-id="select-key-result-type-button"
                    uiId="metric-type-selector"></metric-type-selector>
                  <help-tooltip [content]="typeTemplate"></help-tooltip>
                </div>
              </div>
              <div class="form-row" *ngIf="form.controls.type.value.manualType === 'double' || form.controls.type.value.manualType === '' || this.form.controls.automation.value.insightName !== ''">
                <label class="section-label" for="unit">{{ "unit" | localize }}</label>
                <div class="section-field">
                  <unit-selector [reserveScrollbarSpace]="false" [a11yDescription]="'unit_represents_kr_accounted_expressed_can_create_custom' | localize" formControlName="format"></unit-selector>
                  <help-tooltip [content]="formatTemplate"></help-tooltip>
                </div>
              </div>
              <div class="form-row" *ngIf="form.controls.type.value.manualType === 'double' || form.controls.type.value.manualType === '' || this.form.controls.automation.value.insightName !== ''">
                <label class="section-label" for="metric-target-value">{{ "target_number" | localize }}<span aria-hidden="true">*</span></label>
                <div class="section-field">
                  <metric-number-input-field
                    class="metric-number"
                    [selected]="metric.target"
                    [defaultValue]="null"
                    [a11yRequired]="true"
                    [prefix]="form.controls.format.value.prefix"
                    [suffix]="form.controls.format.value.suffix"
                    [a11yDescription]="('target_represents_what_to_achieve' | localize) + ' ' + ('increase_rev_twenty_thirty_has_target_thirty' | localize)"
                    formControlName="target"
                    e2eTestId="key-result-modal-target-number-input"
                    uiId="metric-target-value"></metric-number-input-field>
                  <help-tooltip [content]="targetTemplate"></help-tooltip>
                </div>
              </div>
              <div
                *ngIf="
                  (form.controls.useCritical.value || !metric.sourceMetricId) &&
                  (form.controls.type.value?.['manualType'] === 'double' || form.controls.type.value?.['manualType'] === '') &&
                  (form.controls.type.value?.['targetOperator'] === 'should_stay_above' || form.controls.type.value?.['targetOperator'] === 'should_stay_below')
                ">
                <div class="form-row critical-slider-row" [hidden]="goal.locked && isEdit">
                  <div class="critical-slider" [ngClass]="{ disabled: !form.controls.useCritical.value }">
                    <span class="slider-label gh-mr-1" id="use-additional-critical-target">{{ "use_additional_critical_target" | localize }}</span>
                    <ui-toggle formControlName="useCritical" labelledby="use-additional-critical-target"></ui-toggle>
                  </div>
                </div>
                <div class="form-row" *ngIf="form.controls.useCritical.value" [ngClass]="{ 'row-error': form.errors?.criticalLowerThanTarget || form.errors?.criticalGreaterThanTarget }">
                  <label class="section-label" for="metric-critical-target"
                    ><span>{{ "critical_number" | localize }}</span></label
                  >
                  <div class="section-field">
                    <metric-number-input-field
                      class="metric-number"
                      [errorMessageId]="form.errors?.criticalLowerThanTarget || form.errors?.criticalGreaterThanTarget"
                      [selected]="metric.critical"
                      [placeholder]="'insert_optional_critical_number' | localize"
                      [prefix]="form.controls.format.value.prefix"
                      [suffix]="form.controls.format.value.suffix"
                      [a11yDescription]="('additional_critical_target_is_optional' | localize) + ' ' + ('critical_example_complaints_five_ten' | localize)"
                      formControlName="critical"
                      data-test-id="key-result-modal-target-number-input"
                      uiId="metric-critical-target"></metric-number-input-field>
                    <help-tooltip [content]="criticalTemplate"></help-tooltip>
                    <div class="error-text">
                      <ui-validation-hint
                        id="critical-lower-than-target"
                        *ngIf="form.errors?.criticalLowerThanTarget"
                        [hintContent]="'critical_lower_than_target' | localize"
                        hintType="error"></ui-validation-hint>
                      <ui-validation-hint
                        id="critical-greater-than-target"
                        *ngIf="form.errors?.criticalGreaterThanTarget"
                        [hintContent]="'critical_greater_than_target' | localize"
                        hintType="error"></ui-validation-hint>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-row metric-row"
                *ngIf="form.controls.type.value.manualType === 'double' || form.controls.type.value.manualType === '' || this.form.controls.automation.value.insightName !== ''"
                [ngClass]="{ 'row-error': form.errors?.initialLowerThanTarget || form.errors?.initialGreaterThanTarget }">
                <label class="section-label" for="metric-initial-value">{{ "initial_number" | localize }}<span aria-hidden="true">*</span></label>
                <div class="section-field">
                  <metric-number-input-field
                    class="metric-number"
                    [errorMessageId]="form.errors?.initialLowerThanTarget || form.errors?.initialGreaterThanTarget"
                    [selected]="metric.initialValue"
                    [defaultValue]="null"
                    [a11yRequired]="true"
                    [prefix]="form.controls.format.value.prefix"
                    [suffix]="form.controls.format.value.suffix"
                    [a11yDescription]="('this_starting_point_kr_measured' | localize) + ' ' + ('kr_initial_example_increase_deliveries_five' | localize)"
                    formControlName="initialValue"
                    uiId="metric-initial-value"
                    e2eTestId="key-result-modal-initial-number-input"></metric-number-input-field>
                  <help-tooltip [content]="initialTemplate"></help-tooltip>
                  <div class="error-text">
                    <ui-validation-hint
                      id="initial-lower-than-target"
                      *ngIf="form.errors?.initialLowerThanTarget"
                      [hintContent]="'initial_lower_than_target' | localize"
                      hintType="error"></ui-validation-hint>
                    <ui-validation-hint
                      id="initial-greater-than-target"
                      *ngIf="form.errors?.initialGreaterThanTarget"
                      [hintContent]="'initial_greater_than_target' | localize"
                      hintType="error"></ui-validation-hint>
                  </div>
                </div>
              </div>
              <div class="form-row insight-section" *ngIf="!metric.sourceMetricId && hasPermissionsToDisplayInsightSelector && !(isEdit && metric.cascadeType)">
                <div class="section-label">{{ "automation" | localize }}</div>
                <div class="section-field insight-selector">
                  <item-automation *ngIf="form.controls.automation?.value" [itemTitle]="form.controls.name.value" [itemType]="'kr'" formControlName="automation"></item-automation>
                </div>
              </div>
            </div>
            <div class="form-section description-section">
              <div class="form-row">
                <div class="section-label" id="kr-description-textbox">{{ "description" | localize }}</div>
                <div class="section-field metric-description">
                  <rich-text-editor
                    [text]="form.controls['description'].value"
                    [focusMe]="(focus$ | async) === 'shouldFocusDescriptionInput'"
                    [placeholder]="'enter_description' | localize"
                    [withoutGifs]="true"
                    [hidePostButton]="true"
                    [readOnly]="goal.locked && !isFieldPartOfWorkflow('description')"
                    (blur)="updateFocus(null)"
                    (textChange)="updateDescription($event)"
                    data-test-id="create-key-result-modal-description"
                    a11yLabelledby="kr-description-textbox"></rich-text-editor>
                </div>
              </div>
              <div class="form-row">
                <label class="section-label" for="metric-owner-selector">{{ "owner_cap" | localize }}<span aria-hidden="true">*</span></label>
                <div class="section-field metric-owner">
                  <div>
                    <people-selector
                      [a11yRequired]="true"
                      [preventInfiniteScrolling]="true"
                      [selectedIds]="metric.ownerIds"
                      [atLeastOneValue]="true"
                      [request]="peopleSelectorRequest"
                      [mode]="metricMethodologySettings.multipleOwnersPerMetricDisabled ? 'default' : 'multiple'"
                      [a11yDescription]="'the_kr_could_assigned_another_employee_team' | localize"
                      formControlName="ownerIds"
                      data-test-id="create-kr-modal-owner-field"
                      uiId="metric-owner-selector"></people-selector>
                    <div class="helper-text">{{ "krs_can_be_assigned_to_multiple_people_teams" | localize }}</div>
                  </div>
                </div>
              </div>
              <div
                class="form-row"
                [hidden]="
                  (!dynamicKrsFeatureEnabled || form.controls.type.value.manualType === 'double' || form.controls.type.value.manualType === '') &&
                  (form.controls.type.value.targetOperator === 'should_stay_above' || form.controls.type.value.targetOperator === 'should_stay_below')
                ">
                <label class="section-label" for="metric-deadline-selector">{{ "deadline" | localize }}</label>
                <div class="section-field deadline-field">
                  <metric-deadline-selector
                    [minHardDeadline]="datepickerOptions?.dueDatePicker.minDate.toDate()"
                    [maxHardDeadline]="datepickerOptions?.dueDatePicker.maxDate.toDate()"
                    [minSoftDeadline]="datepickerOptions?.softDueDatePicker.minDate.toDate()"
                    [maxSoftDeadline]="datepickerOptions?.softDueDatePicker.maxDate.toDate()"
                    [a11yDescription]="('can_choose_custom_deadline_default_is_end_session' | localize) + ' ' + ('kr_deadline_example_quarterly_session' | localize)"
                    formControlName="deadline"
                    uiId="metric-deadline-selector"></metric-deadline-selector>
                  <help-tooltip [content]="deadlinesTemplate"></help-tooltip>
                </div>
              </div>
            </div>
            <div class="cf-metric-form" *ngIf="metric">
              <editable-custom-fields
                [borderless]="false"
                [customFieldsFilter]="filterBySessionId"
                (checkRequired)="validateRequiredCustomFields($event)"
                formControlName="customFields"
                formName="migrated-create-metric-form"
                targetType="metric"></editable-custom-fields>
            </div>

            <div class="form-actions" *ngIf="!indicators.saving">
              <button
                *ngIf="!metric.id"
                [disabled]="form.invalid"
                (click)="save()"
                (keydown.enter)="save()"
                ui-button
                data-test-id="key-result-modal-add-key-result-button"
                uiSize="large"
                uiType="primary"
                uiShape="round">
                {{ "add_key_result" | localize }}
              </button>
              <button class="gh-mr-1" *ngIf="metric.id" [disabled]="form.invalid" (click)="edit()" (keydown.enter)="edit()" ui-button uiSize="large" uiType="primary" uiShape="round">
                {{ "save" | localize }}
              </button>
              <button (click)="closeModal()" (keydown.enter)="closeModal()" ui-button uiSize="large" uiType="link" uiShape="round">{{ "cancel" | localize }}</button>
            </div>
            <gh-indicator [ghValue]="indicators.saving" [ghMessage]="'saving' | localize"></gh-indicator>
          </form>
        </div>
      </div>
    </div>
    <div class="pi-indicator" *ngIf="isSuggestingKRInCreateKRFormEnabled && !indicators.loading && !isEdit">
      <pi-suggestion-state-indicator
        [isSelected]="shouldDisplaySuggestionDrawer"
        [statePropagator]="drawerStatePropagator"
        (suggestionStateIndicatorToggle)="onSuggestionDrawerVisibilityChange($event)"></pi-suggestion-state-indicator>
    </div>
  </div>
  <div *ngIf="isSuggestingKRInCreateKRFormEnabled && !indicators.loading && !isEdit">
    <pi-create-metric-suggestion-drawer
      [flowId]="flowId"
      [metricForm]="form"
      [goal]="goal"
      [isOpen]="shouldDisplaySuggestionDrawer"
      [statePropagator]="drawerStatePropagator"
      [visibilityChange]="onSuggestionDrawerVisibilityChange"
      [hasAcceptedTitleSuggestion]="hasAcceptedTitleSuggestion"
      [hasAcceptedDescriptionSuggestion]="hasAcceptedDescriptionSuggestion"
      (suggestions)="updateFormWithSuggestions($event)"
      (focusField)="updateFocus($event)">
    </pi-create-metric-suggestion-drawer>
  </div>
</div>

<ng-template #titleTemplate>
  <div>
    <div>{{ "title_most_visible_part_of_kr_should_be" | localize }}</div>
    <div>
      <b> {{ "example" | localize }}:</b><span> {{ "increase_revenue_from_twenty_to_thirty" | localize }}</span>
    </div>
  </div>
</ng-template>

<ng-template #typeTemplate>
  <div>
    <div id="key-result-type-deng-templateion">{{ "type_of_KR_needed_detemermine_progress_choose_type" | localize }}</div>
    <div id="key-result-type-example">
      <b> {{ "example" | localize }}:</b><span> {{ "maintain_more_than_fifty_subscribers" | localize }}</span>
    </div>
  </div>
</ng-template>

<ng-template #formatTemplate>
  <div>
    <div>{{ "unit_represents_kr_accounted_expressed_can_create_custom" | localize }}</div>
  </div>
</ng-template>

<ng-template #targetTemplate>
  <div>
    <div>{{ "target_represents_what_to_achieve" | localize }}</div>
    <div>
      <b> {{ "example" | localize }}:</b><span> {{ "increase_rev_twenty_thirty_has_target_thirty" | localize }}</span>
    </div>
  </div>
</ng-template>

<ng-template #criticalTemplate>
  <div>
    <div>{{ "additional_critical_target_is_optional" | localize }}</div>
    <div>
      <b> {{ "example" | localize }}:</b><span *ngIf="form.controls.type.value.targetOperator === 'should_stay_below'"> {{ "critical_below_example_complaints_five_ten" | localize }}</span
      ><span *ngIf="form.controls.type.value.targetOperator === 'should_stay_above'"> {{ "critical_above_example_average_price_ten_five" | localize }}</span>
    </div>
  </div>
</ng-template>

<ng-template #initialTemplate>
  <div>
    <div>{{ "this_starting_point_kr_measured" | localize }}</div>
    <div>
      <b> {{ "example" | localize }}:</b><span> {{ "kr_initial_example_increase_deliveries_five" | localize }}</span>
    </div>
  </div>
</ng-template>

<ng-template #deadlinesTemplate>
  <div>
    <div>{{ "can_choose_custom_deadline_default_is_end_session" | localize }}</div>
    <div>
      <b> {{ "example" | localize }}:</b><span> {{ "kr_deadline_example_quarterly_session" | localize }}</span>
    </div>
  </div>
</ng-template>
